import { useEffect, useState } from 'react';
import Menu from '../components/TabMenu';
import SideMenu from '../components/SideMenu';
import GameModeMenu from '../components/GameModeMenu';
import { Link } from 'react-router';
import Ranking from '../components/Ranking';
import { SERVER_HOST } from '../settings';

export default function PlayerRanking() {

    const [rankingType, setRankingType] = useState();
    const [latestBatch, setLatestBatch] = useState('');

    useEffect(() => {
        const url = `${SERVER_HOST}/latestBatches`;
        fetch(url).then(data => data.json()).then((data) => {
            setLatestBatch(new Date(data?.overall)?.toLocaleString());
        })
    });

    const tabContentFn = (gameMode, rankingType) => {
        return <Ranking gameMode={gameMode.key} rankingType={rankingType}></Ranking>;
    }
    return (
        <div>
            <Menu setRankingTypeFn={setRankingType}></Menu>
            <h3 class="text-align-center">Last ranking update: {latestBatch}</h3>
            <GameModeMenu tabContentFn={tabContentFn} rankingType={rankingType}></GameModeMenu>
        </div>
    );
};